export default __webpack_public_path__ + "static/media/preview-equipment-media.58ba75d1.JPG";